 
import { Typography, useTheme } from '@mui/joy';
import { useDonorSectionData } from '../../providers/DonorSectionProvider';
import DonorDisaggChart from './DonorDisaggChart';
import { Fragment } from 'react';

const DonorDisaggCharts = ({
	topic,
	i,
	print
}: {
	topic: string;
	i: number;
	print?: boolean;
}) => {
	const theme = useTheme();
	const { chartData } = useDonorSectionData();

	const names = ['US Senate', 'US House'];
	return (
		<>
			{chartData && chartData.length
				? chartData[i]?.map((array, j) => {
						return (
							<Fragment key={`${i}${names[j]}`}>
								<Typography
									level={'label'}
									sx={{
										padding: '1rem 0',
										color:
											theme.colorSchemes.light.palette.chartElementsBackground
												.xAxisLabels
									}}
								>
									{names[j]}
								</Typography>
								<DonorDisaggChart
									chartData={array}
									topic={topic}
									title={names[j]}
									print={print}
								/>
							</Fragment>
						);
				  })
				: null}
		</>
	);
};

export default DonorDisaggCharts;
